import type { Schedule } from '../types/schedules';
import _teachers from './teachers';
import _locations from './locations';
import _groups from './groups';
import _courses from './courses';
import _events from './events';
import _persons from './persons';
import type { CoreTypes } from '../../core';
import type { InternalIdKey } from '../../core/types/common';


export namespace OutTypes {
  export type location = Omit<CoreTypes.Serialized.Location, InternalIdKey>;
  export type teacher  = Omit<CoreTypes.Serialized.Teacher,  InternalIdKey>;
  export type group    = Omit<CoreTypes.Serialized.Group,    InternalIdKey>;
  export type course   = Omit<CoreTypes.Serialized.Course,   InternalIdKey>;
  export type event    = Omit<CoreTypes.Serialized.Event,    InternalIdKey>;
  export type person   = Omit<CoreTypes.Serialized.Person,   InternalIdKey>;
};

export default function (
  schedule: Omit<Schedule, 'start_date' | 'end_date' | 'schedule' | 'school_year'>
) {

  ////
  //// check the number of contained schools
  ////
  if (schedule.schools.length != 1) {
    return { meta: { errors: [`Received ${schedule.schools.length} number of schools: only a single school is allowed.`] } };
  }
  const school = schedule.schools[0];

  const courseMap = new Map<number, OutTypes.course[]>();
  // gather all import related warnings/errors
  const errors:   string[] = [];
  const warnings: string[] = [];

  const locations: OutTypes.location[] = _locations(schedule.rooms,                              errors, warnings);
  const teachers:  OutTypes.teacher [] = _teachers (schedule.schedule_groups, schedule.lessons,  errors, warnings);
  const groups:    OutTypes.group   [] = _groups   (schedule.primary_groups,                     errors, warnings);
  const courses:   OutTypes.course  [] = _courses  (schedule.schedule_groups, school, courseMap, errors, warnings);
  const events:    OutTypes.event   [] = _events   (schedule.lessons, courseMap, teachers,       errors, warnings);
  const persons:   OutTypes.person  [] = _persons  (schedule.users, groups,                      errors, warnings);

  return { locations, teachers, groups, courses, events, persons,
    meta: {
      ...( errors.length   ? { errors }   : { } ),
      ...( warnings.length ? { warnings } : { } )
    }
  };
}
